import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { fetchPublicForm } from "../../lib/publicLeadApi";

export default function PublicThankYou() {
  const { slug } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchPublicForm(slug)
      .then((data) => alive && setForm(data))
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [slug]);

  useEffect(() => {
    document.title = "Entrena Tu Centro";
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 size={32} className="animate-spin text-gray-400" />
      </div>
    );
  }

  const color = form?.primary_color || "#10b981";
  const message =
    form?.thank_you_message ||
    "Hemos recibido tu solicitud. Te contactaremos lo antes posible.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 max-w-md w-full text-center animate-fade-in">
        <CheckCircle2
          size={56}
          className="mx-auto mb-4"
          style={{ color }}
        />
        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          ¡Gracias!
        </h1>
        <p className="text-sm text-gray-600">{message}</p>
      </div>
    </div>
  );
}
